var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C12.5 0 14.5312 1.15625 16 2.53125C17.4688 3.875 18.4375 5.5 18.9062 6.625C19 6.875 19 7.15625 18.9062 7.40625C18.4375 8.5 17.4688 10.125 16 11.5C14.5312 12.875 12.5 14 10 14C7.46875 14 5.4375 12.875 3.96875 11.5C2.5 10.125 1.53125 8.5 1.0625 7.40625C0.96875 7.15625 0.96875 6.875 1.0625 6.625C1.53125 5.5 2.5 3.875 3.96875 2.53125C5.4375 1.15625 7.46875 0 10 0ZM5.5 7C5.5 8.625 6.34375 10.0938 7.75 10.9062C9.125 11.7188 10.8438 11.7188 12.25 10.9062C13.625 10.0938 14.5 8.625 14.5 7C14.5 5.40625 13.625 3.9375 12.25 3.125C10.8438 2.3125 9.125 2.3125 7.75 3.125C6.34375 3.9375 5.5 5.40625 5.5 7ZM10 5C10 4.78125 9.9375 4.59375 9.875 4.375C9.8125 4.21875 9.9375 4 10.125 4C11.375 4.0625 12.5312 4.9375 12.875 6.25C13.3125 7.84375 12.375 9.46875 10.75 9.90625C9.15625 10.3438 7.5 9.375 7.09375 7.78125C7.03125 7.5625 7 7.34375 7 7.15625C6.96875 6.96875 7.1875 6.84375 7.34375 6.90625C7.5625 6.96875 7.75 7 8 7C9.09375 7 10 6.125 10 5Z",
    fill: "url(#paint0_linear_3780_5354)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3780_5354",
    x1: 1.5,
    y1: -1,
    x2: 17,
    y2: 14.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#0D0C13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0EFF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.f19230286972001a983cc701dcd26d10.svg";
export { ForwardRef as ReactComponent };